import axiosInstance from '@/api/axiosInstance';

const mapMeetingFromApi = (item) => ({
  id: item.id,
  codigo: item.codigo,
  titulo: item.titulo,
  descripcion: item.descripcion,
  fecha: item.fecha_reunion ? item.fecha_reunion.substr(0, 10) : '',
  fecha_reunion: item.fecha_reunion,
  lugar: item.lugar,
  portada: item.portada || '',
  activo: item.activo === '1' || item.activo === 1 || item.activo === true,
});

const mapGuestFromApi = (item) => {
  const nombre =
    item.socio_nombre ||
    item.invitado_nombre ||
    item.nombre_manual ||
    '';
  const correo =
    item.socio_email ||
    item.invitado_email ||
    item.email_manual ||
    '';

  const correoEnviado =
    item.correo_enviado === 1 ||
    item.correo_enviado === '1' ||
    item.correo_enviado === true;
  const statusCorreo = correoEnviado ? 'Enviado' : 'Pendiente';
  // map asistencia: pendiente|confirmado|rechazado -> UI labels (solo 3 estados)
  let asistencia = 'Pendiente';
  if (item.estado_asistencia === 'confirmado') asistencia = 'Asistió';
  if (item.estado_asistencia === 'rechazado') asistencia = 'Faltó';

  return {
    id: item.id,
    codigo: item.codigo,
    tipo: item.tipo_participante === 'manual' ? 'extra' : item.tipo_participante,
    nombre,
    correo,
    socio_id: item.socio_id || null,
    numeroSocio: item.numero_socio || item.socio_id || '',
    nombreSocio: item.nombre_socio || item.socio_nombre || '',
    vigencia: item.socio_vigencia || '',
    invitado_id: item.invitado_id || null,
    representante: item.rep_nombre || '',
    correoRepresentante: item.rep_email || '',
    estatusCorreo: statusCorreo,
    estatusAsistencia: asistencia,
    faltaJustificada:
      item.falta_justificada === 1 ||
      item.falta_justificada === '1' ||
      item.falta_justificada === true,
  };
};

const mapGuestToApi = (meetingId, guest) => {
  const tipo = guest.tipo === 'extra' ? 'manual' : guest.tipo || 'manual';
  const base = {
    id: guest.id || null,
    reunion_id: meetingId,
    codigo: guest.codigo || '',
    tipo_participante: tipo,
    correo_enviado: guest.estatusCorreo === 'Enviado' ? 1 : 0,
    falta_justificada: guest.faltaJustificada ? 1 : 0,
  };

  // map asistencia UI -> api enum
  const asistencia = (guest.estatusAsistencia || '').toLowerCase();
  if (asistencia === 'asistió' || asistencia === 'asistio') {
    base.estado_asistencia = 'confirmado';
    base.falta_justificada = 0;
  } else if (asistencia === 'faltó' || asistencia === 'falto' || asistencia === 'no asistió' || asistencia === 'no asistio') {
    base.estado_asistencia = 'rechazado';
  } else {
    base.estado_asistencia = 'pendiente';
    base.falta_justificada = 0;
  }

  if (base.tipo_participante === 'socio') {
    base.socio_id = guest.socio_id || null;
    base.rep_nombre = guest.representante || '';
    base.rep_email = guest.correoRepresentante || '';
  } else if (base.tipo_participante === 'invitado') {
    base.invitado_id = guest.invitado_id || null;
    base.rep_nombre = guest.representante || '';
    base.rep_email = guest.correoRepresentante || '';
  } else {
    base.nombre_manual = guest.nombre || '';
    base.email_manual = guest.correo || '';
    base.telefono_manual = guest.telefono || '';
    base.rep_nombre = guest.representante || '';
    base.rep_email = guest.correoRepresentante || '';
  }

  return base;
};

const actions = {
  async fetchList({ commit }, queryParams = {}) {
    try {
      const url = '/meetings/list';
      const params = new URLSearchParams(queryParams);
      const response = await axiosInstance.get(`${url}?${params.toString()}`);

      if (response?.status === 200 && response?.data?.data?.meetings) {
        const payload = response.data.data.meetings;
        const list = (payload.list || []).map(mapMeetingFromApi);
        const pagination = payload.pagination || {};

        if (pagination.page === 1) {
          commit('INIT_STATE');
        }

        commit('SET_DATA', { key: 'meetings', data: list });
        commit('SET_DATA', { key: 'list', data: list });
        commit('SET_DATA', { key: 'pagination', data: pagination });
        commit('SET_DATA', { key: 'formSend', data: false });
        return list;
      }
      throw new Error('No se pudo obtener el listado');
    } catch (error) {
      console.error('Error al obtener reuniones:', error);
      throw error;
    }
  },

  async saveMeeting({ commit }, meetingData) {
    try {
      const url = '/meetings/save';
      const fd = new FormData();

      if (meetingData.id) fd.append('id', meetingData.id);
      fd.append('titulo', meetingData.titulo || '');
      fd.append('descripcion', meetingData.descripcion || '');
      fd.append('fecha_reunion', meetingData.fecha || meetingData.fecha_reunion || '');
      fd.append('lugar', meetingData.lugar || '');
      fd.append('activo', meetingData.activo ? 1 : 0);
      if (meetingData.codigo) fd.append('codigo', meetingData.codigo);
      if (meetingData.imagenFile) {
        fd.append('imagenes_id', meetingData.imagenFile);
      }

      const response = await axiosInstance.post(url, fd);
      if (response?.status === 200) {
        commit('SET_DATA', { key: 'formSend', data: true });
        commit('SET_DATA', { key: 'reloadList', data: true });
        return response.data;
      }
      throw new Error('No se pudo guardar la reunión');
    } catch (error) {
      console.error('Error al guardar reunión:', error);
      throw error;
    }
  },

  async fetchMeeting({ state, commit, dispatch }, id) {
    // Si ya está en memoria, úsalo
    let meeting = state.meetings.find((item) => item.id === Number(id) || item.id === id);

    if (!meeting) {
      // Forzar fetch y buscar por id.
      // Nota: el backend legacy puede ignorar el filtro `id` en `/meetings/list`,
      // así que intentamos primero con `id`, y si no se encuentra, hacemos fallback
      // trayendo una página grande.
      let list = [];
      try {
        list = await dispatch('fetchList', { id, page: 1, size: 1 });
      } catch (e) {
        list = [];
      }

      meeting = list.find((item) => item.id === Number(id) || item.id === id) || null;

      if (!meeting) {
        try {
          list = await dispatch('fetchList', { page: 1, size: 5000 });
        } catch (e) {
          list = [];
        }
        meeting = list.find((item) => item.id === Number(id) || item.id === id) || null;
      }
    }

    commit('SET_DATA', { key: 'currentMeeting', data: meeting });
    if (meeting) {
      await dispatch('fetchGuests', meeting.id);
    } else {
      commit('SET_DATA', { key: 'currentGuests', data: [] });
    }

    return meeting;
  },

  async removeMeeting({ commit }, id) {
    try {
      const url = `/meetings/destroy/${id}`;
      const response = await axiosInstance.delete(url);
      if (response?.status === 200) {
        commit('REMOVE_MEETING', id);
        commit('SET_DATA', { key: 'reloadList', data: true });
        return response.data;
      }
      throw new Error('No se pudo eliminar la reunión');
    } catch (error) {
      console.error('Error al eliminar reunión:', error);
      throw error;
    }
  },

  async fetchGuests({ commit }, meetingId) {
    try {
      const url = '/meetings/participants_list';
      const params = new URLSearchParams({ reunion_id: meetingId, size: 200, page: 1 });
      const response = await axiosInstance.get(`${url}?${params.toString()}`);
      if (response?.status === 200 && response?.data?.data?.participants) {
        const payload = response.data.data.participants;
        const list = (payload.list || []).map(mapGuestFromApi);
        commit('UPSERT_GUESTS', { meetingId, guests: list });
        commit('SET_DATA', { key: 'currentGuests', data: list });
        return list;
      }
      throw new Error('No se pudo obtener invitados');
    } catch (error) {
      console.error('Error al obtener invitados:', error);
      throw error;
    }
  },

  async saveGuest({ dispatch }, { meetingId, guest }) {
    try {
      const url = '/meetings/participants_save';
      const payload = mapGuestToApi(meetingId, guest);
      const response = await axiosInstance.post(url, payload);
      if (response?.status === 200) {
        // refrescar lista
        await dispatch('fetchGuests', meetingId);
        return response.data;
      }
      throw new Error('No se pudo guardar el invitado');
    } catch (error) {
      console.error('Error al guardar invitado:', error);
      throw error;
    }
  },

  async removeGuests({ dispatch }, { meetingId, ids }) {
    try {
      const payload = { reunion_id: meetingId, ids };
      await axiosInstance.post('/meetings/participants_destroy_bulk', payload);
      await dispatch('fetchGuests', meetingId);
      return { status: true, message: 'Invitados eliminados', data: ids };
    } catch (error) {
      console.error('Error al eliminar invitados:', error);
      throw error;
    }
  },

  async updateGuestsStatus({ state, dispatch }, { meetingId, ids, updates }) {
    try {
      const current = state.guestsByMeeting[meetingId] || [];
      for (const id of ids) {
        const guest = current.find((g) => g.id === id);
        if (!guest) continue;
        const payload = { ...guest, ...updates };
        await dispatch('saveGuest', { meetingId, guest: payload });
      }
      return { status: true, message: 'Invitados actualizados', data: ids };
    } catch (error) {
      console.error('Error al actualizar invitados:', error);
      throw error;
    }
  },
};

export default actions;
